import { store } from "@/src/store";
import { tasksPageRequests } from "@/src/api/tasksPageRequests";

export const resolvePrefillTaskAttachedFile = async (
  taskId: string,
  localCandidates: (string | undefined | null)[],
): Promise<string> => {
  for (const candidate of localCandidates) {
    const trimmed = String(candidate ?? "").trim();
    if (trimmed) return trimmed;
  }

  const normalizedTaskId = taskId.trim();
  if (!normalizedTaskId) return "";

  const rawTask = await tasksPageRequests.fetchById(normalizedTaskId);
  return rawTask?.attached_file?.trim() ?? "";
};

export const readAdmissionFormAttachedFile = (): string =>
  String(store.getState().admissionOfficeDoc.attachedFile ?? "").trim();
